/**
 * 艺术风格提取工具
 * 从项目设定的艺术风格内容中提取基础提示词
 */

/**
 * 从艺术风格设定中提取基础提示词
 * 
 * 优先级：
 * 1. 如果有【基础提示词】或【正向提示词】章节，提取其内容
 * 2. 如果没有，提取【风格名称】
 * 3. 如果再没有，返回完整内容
 * 
 * @param artStyleContent 项目设定中的艺术风格内容
 * @returns 提取的基础提示词
 */
export function extractBasePromptFromArtStyle(artStyleContent: string): string {
  if (!artStyleContent || !artStyleContent.trim()) {
    return '';
  }

  const content = artStyleContent.trim();

  // 1. 尝试提取【基础提示词】章节后的内容（直到下一个【】或结尾）
  const basePromptMatch = content.match(/【基础提示词】\s*[\r\n]+([\s\S]*?)(?=【|$)/i);
  if (basePromptMatch && basePromptMatch[1]) {
    const extracted = basePromptMatch[1].trim();
    // 如果有"正向提示词："标签，提取其后内容
    const withLabelMatch = extracted.match(/正向提示词[：:]\s*([\s\S]+)/i);
    if (withLabelMatch && withLabelMatch[1]) {
      return withLabelMatch[1].trim();
    }
    return extracted;
  }

  // 2. 尝试直接提取【正向提示词】
  const positivePromptMatch = content.match(/正向提示词[：:]\s*([^\n【]+)/i);
  if (positivePromptMatch && positivePromptMatch[1]) {
    return positivePromptMatch[1].trim();
  }

  // 3. 尝试提取【风格名称】
  const styleNameMatch = content.match(/【风格名称】\s*[\r\n]+\s*([^\n【]+)/i);
  if (styleNameMatch && styleNameMatch[1]) {
    return styleNameMatch[1].trim();
  }

  // 4. 如果都没有，返回完整内容（截取前200字符）
  return content.substring(0, 200);
}
